import { render, staticRenderFns } from "./Observability.vue?vue&type=template&id=4c837136&"
import script from "./Observability.vue?vue&type=script&lang=js&"
export * from "./Observability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports